import Datepicker from "./Datepicker/Datepicker.vue";

const ComponentPlugin = {
  install(Vue) {
    [Datepicker].forEach((component) => {
      Vue.component(component.name, component);
    });
  },
};

export default ComponentPlugin;
